import { render, staticRenderFns } from "./DragGhostElement.vue?vue&type=template&id=4c4a19e7&"
import script from "./DragGhostElement.vue?vue&type=script&lang=ts&"
export * from "./DragGhostElement.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports